module.exports = __webpack_public_path__ + "img/Clutch.92c9270b.webp";